export const loaderStore = {
  state: {
    postcardsLoaded: false,
    postcards: []
  },
  getters: {
    isPostcardsLoaded: state => {
      return state.postcardsLoaded;
    },
    getPostcards: state => {
      return state.postcards;
    },
  },
  mutations: {
    setPostcardsLoaded(state, value) {
      state.postcardsLoaded = value;
    },
    setPostcards(state, value) {
      state.postcards = value;
    }
  }
};
